import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Grid, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import routes from './routes';
import { auth } from './firebaseConfig';
import PrimaryButton from './components/PrimaryButton';

const CreateContract = () => {
  const navigate = useNavigate();

  const [contractDetails, setContractDetails] = useState({
    contractName: 'Contrato de Prestação de Serviços de Desenvolvimento de Software',
    contractorName: '',
    contractorCPF: '',
    contractorEmail: '',
    contractedName: '',
    contractedCPF: '',
    contractedEmail: '',
    object: '',
    scope: '',
    notIncluded: '',
    deadline: '',
    intermediateDeliveries: '',
    totalValue: '',
    paymentTerms: '',
    revisions: '',
    terminationByClient: '',
    terminationByContractor: '',
    guarantees: '',
    contractorObligations: '',
    contractedObligations: '',
    additionalClauses: '',
  });

  const [isSigned, setIsSigned] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate(routes.HOME);
        return;
      }

      const userId = user.uid;
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/users/${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${await user.getIdToken(true)}`,
          },
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        setContractDetails((prev) => ({
          ...prev,
          contractedName: responseData.response.name,
          contractedCPF: responseData.response.cpf,
          contractedEmail: responseData.response.email,
        }));
      } else {
        console.error('Failed to fetch user data');
      }
    };

    fetchUser();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContractDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCreateContract = () => {
    console.log('Detalhes do contrato:', contractDetails);
    // Logic to save the contract and generate PDF
    alert('Contrato criado com sucesso!');
  };

  const handleSignAsContractor = () => {
    console.log('Assinado como contratante');
    setIsSigned(true);
    // Logic to sign as contractor
    alert('Assinado como contratante');
  };

  const handleSignAsContracted = () => {
    console.log('Assinado como contratado');
    setIsSigned(true);
    // Logic to sign as contracted
    alert('Assinado como contratado');
  };

  const isFormComplete = () => {
    return Object.values(contractDetails).every(value => value.trim() !== '') && isSigned;
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Paper sx={{ padding: 3, maxWidth: 800, margin: 'auto' }} elevation={3}>
        <TextField
          label="Título do contrato"
          name="contractName"
          value={contractDetails.contractName}
          onChange={handleChange}
          fullWidth
          placeholder="Ex: Contrato de Prestação de Serviços de Desenvolvimento de Software"
        />

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            1. Identificação das partes
          </Typography>
          <Typography variant="h6" gutterBottom>
            Contratante:
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Nome"
                name="contractorName"
                value={contractDetails.contractorName}
                onChange={handleChange}
                fullWidth
                placeholder="Ex: Nome Completo do Cliente"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="CPF/CNPJ"
                name="contractorCPF"
                value={contractDetails.contractorCPF}
                onChange={handleChange}
                fullWidth
                placeholder="Ex: 123.456.789-00"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="E-mail"
                name="contractorEmail"
                value={contractDetails.contractorEmail}
                onChange={handleChange}
                fullWidth
                placeholder="Ex: cliente@exemplo.com"
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            Contratado:
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Nome"
                name="contractedName"
                value={contractDetails.contractedName}
                onChange={handleChange}
                fullWidth
                placeholder="Ex: Seu Nome Completo"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="CPF/CNPJ"
                name="contractedCPF"
                value={contractDetails.contractedCPF}
                onChange={handleChange}
                fullWidth
                placeholder="Ex: 987.654.321-00"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="E-mail"
                name="contractedEmail"
                value={contractDetails.contractedEmail}
                onChange={handleChange}
                fullWidth
                placeholder="Ex: voce@exemplo.com"
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            2. OBJETO DO CONTRATO
          </Typography>
          <Typography variant="body1" gutterBottom>
            Este contrato tem por objeto a prestação de serviços de desenvolvimento de software, conforme descrito abaixo:
          </Typography>
          <TextField
            name="object"
            value={contractDetails.object}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
            placeholder="Ex: Desenvolvimento de uma aplicação mobile de e-commerce..."
          />
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            3. ESCOPOS E RESPONSABILIDADES
          </Typography>
          <Typography variant="body1" gutterBottom>
            O <strong>Contratado</strong> se compromete a entregar os seguintes itens como parte do projeto:
          </Typography>
          <TextField
            name="scope"
            value={contractDetails.scope}
            onChange={handleChange}
            fullWidth
            multiline
            rows={4}
            placeholder="Ex: Design das telas principais, Implementação de funcionalidades essenciais..."
          />

          <Typography variant="body1" gutterBottom sx={{ marginTop: 1 }}>
            Não está incluso neste contrato:
          </Typography>
          <TextField
            name="notIncluded"
            value={contractDetails.notIncluded}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
            placeholder="Ex: Configuração de servidores ou hospedagem do sistema. Suporte após a entrega final do projeto."
          />
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            4. PRAZOS E CRONOGRAMA
          </Typography>
          <Typography variant="body1" gutterBottom>
            O <strong>Contratado</strong> se compromete a entregar o escopo acordado em:
          </Typography>
          <TextField
            name="deadline"
            value={contractDetails.deadline}
            onChange={handleChange}
            fullWidth
            placeholder="Ex: 30 de abril de 2025"
          />
          <Typography variant="body1" gutterBottom sx={{ marginTop: 1 }}>
            Entrega intermediária:
          </Typography>
          <TextField
            name="intermediateDeliveries"
            value={contractDetails.intermediateDeliveries}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
            placeholder="Ex: Semana 1: Aprovação de wireframes; Semana 2: Desenvolvimento do backend funcional..."
          />
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            5. CONDIÇÕES DE PAGAMENTO
          </Typography>
          <Typography variant="body1" gutterBottom>
            O valor total do projeto será de:
          </Typography>
          <TextField
            name="totalValue"
            value={contractDetails.totalValue}
            onChange={handleChange}
            fullWidth
            placeholder="Ex: R$ 5000"
          />
          <Typography variant="body1" gutterBottom sx={{ marginTop: 1 }}>
            Com pagamento parcelado nas seguintes condições:
          </Typography>
          <TextField
            name="paymentTerms"
            value={contractDetails.paymentTerms}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
            placeholder="Ex: 30% na assinatura do contrato, 40% após entrega da funcionalidade..."
          />
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            6. REVISÕES E AJUSTES
          </Typography>
          <TextField
            name="revisions"
            value={contractDetails.revisions}
            onChange={handleChange}
            fullWidth
            multiline
            rows={3}
            placeholder="Ex: O Contratante terá direito a até 3 rodadas de ajustes durante a fase de testes. Ajustes adicionais ou alterações fora do escopo inicial serão cobrados à parte, no valor de R$ 100,00 por hora."
          />
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            7. RESCISÃO E GARANTIAS
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Pelo Contratante:</strong>
          </Typography>
          <TextField
            name="terminationByClient"
            value={contractDetails.terminationByClient}
            onChange={handleChange}
            fullWidth
            multiline
            rows={2}
            placeholder="Ex: Caso o Contratado não entregue o produto dentro do prazo acordado, após aviso prévio de 15 dias."
          />
          <Typography variant="body1" gutterBottom sx={{ marginTop: 1 }}>
            <strong>Pelo Contratado:</strong>
          </Typography>
          <TextField
            name="terminationByContractor"
            value={contractDetails.terminationByContractor}
            onChange={handleChange}
            fullWidth
            multiline
            rows={2}
            placeholder="Ex: Caso o Contratante não efetue os pagamentos conforme acordado, após 15 dias de atraso."
          />
          <Typography variant="body1" gutterBottom sx={{ marginTop: 1 }}>
            <strong>Garantias:</strong>
          </Typography>
          <TextField
            name="guarantees"
            value={contractDetails.guarantees}
            onChange={handleChange}
            fullWidth
            multiline
            rows={2}
            placeholder="Ex: O Contratado se compromete a corrigir quaisquer erros ou bugs no sistema dentro de 30 dias após a entrega final. Ajustes fora do escopo ou adicionais serão cobrados à parte."
          />
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            8. OBRIGAÇÕES DAS PARTES
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Do Contratante:</strong>
          </Typography>
          <TextField
            name="contractorObligations"
            value={contractDetails.contractorObligations}
            onChange={handleChange}
            fullWidth
            multiline
            rows={7}
            placeholder="Ex: - Fornecer todas as informações necessárias para a realização do projeto, incluindo requisitos funcionais e técnicos, logotipos, imagens, credenciais de acesso a servidores, APIs e outros materiais relevantes.
- Validar e aprovar entregas intermediárias dentro dos prazos acordados, para não comprometer o cronograma do projeto.
- Garantir disponibilidade para reuniões, testes e revisões, conforme necessário.
- Efetuar os pagamentos conforme estipulado neste contrato."
          />
          <Typography variant="body1" gutterBottom sx={{ marginTop: 1 }}>
            <strong>Do Contratado:</strong>
          </Typography>
          <TextField
            name="contractedObligations"
            value={contractDetails.contractedObligations}
            onChange={handleChange}
            fullWidth
            multiline
            rows={7}
            placeholder="Ex: - Desenvolver o software de acordo com o escopo, prazos e padrões de qualidade definidos.
- Manter o Contratante informado sobre o progresso do projeto por meio de relatórios regulares ou reuniões.
- Realizar testes no software desenvolvido e corrigir eventuais falhas antes da entrega.
- Fornecer documentação técnica e de uso referente ao sistema entregue.
- Oferecer suporte técnico pós-entrega para correção de erros ou bugs durante o período de garantia.
"
          />
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            9. CLÁUSULAS ADICIONAIS
          </Typography>
          <TextField
            name="additionalClauses"
            value={contractDetails.additionalClauses}
            onChange={handleChange}
            fullWidth
            multiline
            rows={8}
            placeholder="Ex: - Ambas as partes comprometem-se a manter sigilo sobre informações confidenciais trocadas durante o projeto.
- Após a quitação total do contrato, todos os direitos sobre o software desenvolvido serão do Contratante.
- O Contratado terá direito de reutilizar trechos genéricos do código (não exclusivos) em futuros trabalhos.
- Caso o Contratante atrase a entrega de materiais essenciais para o desenvolvimento, o prazo final será prorrogado proporcionalmente."
          />
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <Typography variant="h6" gutterBottom>
            10. DISPOSIÇÕES GERAIS
          </Typography>
          <Typography variant="body1" gutterBottom>
            Este contrato é regido pelas leis brasileiras. Em caso de litígio, as partes concordam em resolver a disputa por meio de mediação ou arbitragem, se necessário.
          </Typography>
        </Box>

        <Box sx={{ marginTop: 3, display: 'flex', justifyContent: 'space-between' }}>
          <PrimaryButton
            variant="contained"
            color="primary"
            onClick={handleSignAsContractor}
            sx={{ marginRight: 1 }}
          >
            Assinar como contratante
          </PrimaryButton>
          <PrimaryButton
            variant="contained"
            color="primary"
            onClick={handleSignAsContracted}
            sx={{ marginLeft: 1 }}
          >
            Assinar como contratado
          </PrimaryButton>
        </Box>

        <Box sx={{ marginTop: 3 }}>
          <PrimaryButton
            onClick={handleCreateContract}
            fullWidth
            disabled={!isFormComplete()}
          >
            Criar contrato
          </PrimaryButton>
        </Box>
      </Paper>
    </Box>
  );
};

export default CreateContract;